// 2024-07-08 - Moved from formsviewer.domain.js
function UpgradeSettings() {}

UpgradeSettings.prototype.type = '';
UpgradeSettings.prototype.transform = '';
UpgradeSettings.prototype.minVersion = '';
UpgradeSettings.prototype.maxVersion = '';

export default UpgradeSettings;
